import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/data.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { RouteHistoryService } from 'src/app/shared/services/router-history.service';

@Component({
  selector: 'app-detail-aha-gold-prompt',
  templateUrl: './detail-aha-gold-prompt.component.html',
  styleUrls: ['./detail-aha-gold-prompt.component.scss'],
})
export class DetailAhaGoldPromptComponent implements OnInit, OnDestroy {
  label = 'go_home';
  isBackPressed = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogService: DialogService,
    private readonly dataService: DataService,
    private readonly routeHistoryService: RouteHistoryService
  ) {
    if (data?.buttonText) {
      this.label = data.buttonText;
    }
  }

  ngOnInit(): void {
    if (this.data.redirectFrom === 'player') {
      this.dataService.disablePlayerListener = true;
    }
  }

  ngOnDestroy(): void {
    if (this.dataService.disablePlayerListener) {
      this.dataService.disablePlayerListener = false;
    }
  }

  disabled(event: any, onBack: boolean = false) {
    if (onBack && !this.isBackPressed) {
      this.isBackPressed = true;
      this.goHomeAction();
    }

    event.preventDefault();
    event.stopPropagation();
  }

  goHomeAction() {
    if (this.label === 'go_home') {
      this.dialogService.closeAll();
      this.routeHistoryService.goBack();
    } else {
      setTimeout(() => {
        this.dialogService.close();
      }, 0);
      if (this.data.redirectFrom === 'player') {
        this.routeHistoryService.goBack();
      }
    }
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }
}
